import type { IconSvgObject } from './types';

const ChartAnalysisIcon: IconSvgObject = [
  ["path", { d: "M3 11L8 6L13 11L21 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 15V21M9 13V21M15 16V21M21 9V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartAnalysisIcon;
